// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3b397cfe-97be-41f2-b88a-1af8489a4ec0',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Today\'s',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#6d0480',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          y: 13,
          text: 'di Oggi'
        },
        fr_FR: {
          y: 13,
          text: 'du Jour'
        },
        de_DE: {
          y: -11,
          text: 'Heutiger'
        },
        es_ES: {
          text: 'de Hoy',
          y: 13
        },
        pt_PT: {
          y: 13,
          text: 'de Hoje'
        },
        pl_PL: {
          text: 'Dzisiejszy'
        },
        nl_NL: {
          text: 'van Vandaag',
          y: 13
        },
        ko_KR: {
          text: '오늘의',
          style: {
            fontWeight: 'bolder'
          },
          y: -13
        },
        ja_JP: {
          text: '本日の',
          style: {
            fontWeight: 'bolder'
          },
          y: -14
        }
      }
    },
    {
      id: 'b166210d-384e-4b1d-ae03-e116324a6631',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'JACKPOT',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#6d0480',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          y: -8,
          style: {
            fontSize: 25
          }
        },
        fr_FR: {
          y: -8,
          style: {
            fontSize: 25
          }
        },
        es_ES: {
          y: -8,
          style: {
            fontSize: 25
          }
        },
        pt_PT: {
          y: -8,
          style: {
            fontSize: 25
          }
        },
        nl_NL: {
          y: -8,
          style: {
            fontSize: 25
          }
        },
        ko_KR: {
          text: '잭팟',
          style: {
            fontWeight: 'bolder',
            fontSize: 25
          }
        },
        ja_JP: {
          text: 'ジャックポット',
          style: {
            fontWeight: 'bolder',
            letterSpacing: -5,
            fontSize: 24
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'en_US',
    'it_IT',
    'fr_FR',
    'de_DE',
    'es_ES',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP'
  ],
  handleResize: false
} as const;

export class LuckyWheelTodayJackpotLocalizationsLayout {
  static raw = raw;
  root!: Container;
  locaSkin_SPL!: (Container)[];
  StateName!: 'en_US' | 'it_IT' | 'fr_FR' | 'de_DE' | 'es_ES' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'ja_JP';

  constructor() {
    populate(this, raw);
  }
}
